export const UNSUPPORTED_PRODUCT = "unsupported_product";

export const MESSAGING_INSIGHTS_PRODUCT_CATEGORY = "support_messaging_insights";

export const LIVE_CHAT_SUPPORTED_PRODUCTS = [
  {
    label: "Account Administration",
    value: "support_accounts_billing",
  },
  {
    label: "Messaging",
    value: "support_messaging",
  },
  {
    label: "Phone Numbers",
    value: "support_phone_numbers",
  },
  {
    label: "Voice",
    value: "support_voice",
  },
  {
    label: "Don't see what you need?",
    value: UNSUPPORTED_PRODUCT,
  },
];

export const SGHC_LIVE_CHAT_SUPPORTED_PRODUCTS = [
  {
    label: "Email API",
    value: "prod_email_api",
  },
  {
    label: "Marketing Campaigns",
    value: "prod_marketing_campaigns",
  },
];

export const mapInferredProductToSupportedProduct = (
  inferredProduct?: string
) => {
  if (inferredProduct) {
    const inferredProductToSupportedProduct: Record<string, string> = {
      prod_numbers: "support_phone_numbers",
      prod_voice: "support_voice",
      prod_messaging: "support_messaging",
      prod_accounts_billing: "prod_account_admin",
      prod_email_api: "prod_email_api",
      prod_marketing_campaigns: "prod_marketing_campaigns",
      [MESSAGING_INSIGHTS_PRODUCT_CATEGORY]:
        MESSAGING_INSIGHTS_PRODUCT_CATEGORY,
    };

    return inferredProductToSupportedProduct[inferredProduct] || "";
  }

  return "";
};
